import React from "react";
import UserBulkUpload from "../screens/users/components/userBulkUpload/userBulkUpload";
import { BulkUploadAction } from "../types/field";

interface Props {
  action: BulkUploadAction;
  moduleName?: string;
  setOpen:(open:boolean)=>void;
}

const BulkUpload: React.FC<Props> = ({ action, moduleName,setOpen }) => {
  return <UserBulkUpload setOpen={setOpen} action={action} moduleName={moduleName}/>;
};

export default BulkUpload;
